import { moveToFulfilled, update } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type {
  AudienceMembersLoadFulfilledAction,
  CreateAudienceFromDirectMembersFulfilledAction,
  CreateAudienceFromOfficeGroupFulfilledAction,
  CreateAudienceFulfilledAction,
  EditAudienceFulfilledAction,
  LeaderAudiencesLoadFulfilledAction,
  UserNetworkLeadersListLoadFulfilledAction,
  UserNetworkLeadersListLoadMoreFulfilledAction,
} from '../../domains/leadersManagement/actions.types';

import type { Audiences } from './types';

export type AudienceAction =
  | AudienceMembersLoadFulfilledAction
  | CreateAudienceFromDirectMembersFulfilledAction
  | CreateAudienceFromOfficeGroupFulfilledAction
  | CreateAudienceFulfilledAction
  | EditAudienceFulfilledAction
  | LeaderAudiencesLoadFulfilledAction
  | UserNetworkLeadersListLoadFulfilledAction
  | UserNetworkLeadersListLoadMoreFulfilledAction;

const initialState: Audiences = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<Audiences, AudienceAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'LEADER_AUDIENCES.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'CREATE_AUDIENCE.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'CREATE_AUDIENCE_FROM_OFFICE_GROUP.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'CREATE_AUDIENCE_FROM_DIRECT_MEMBERS.FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.audiences);
    case 'AUDIENCE_MEMBERS.LOAD_FULFILLED':
      return update(state, action.payload.audienceId, {
        members: action.payload.entities.audienceMembers,
      });
    case 'EDIT_AUDIENCE.FULFILLED':
      return update(state, action.payload.audienceId, action.payload.entities.audiences[action.payload.audienceId]);
    default:
      return state;
  }
};

export default reducer;
